// extracted by mini-css-extract-plugin
module.exports = {"works":"work-list-module--works--1dPwi"};